import React from 'react'

const Loading = () => {
  return (
    <div className='flex justify-center'>
    <div className='bg-gray-500 opacity-50 h-80 w-80 absolute z-50'>
        <h1 className='text-center mt-36 text-white'>Уншиж байна ...</h1>
    </div>
    </div>
  )
}

export default Loading